module.exports = __webpack_public_path__ + "img/B01_HQ07.35389af8.jpg";